import { render, staticRenderFns } from "./remoteService.vue?vue&type=template&id=4956e718&scoped=true&"
import script from "./remoteService.vue?vue&type=script&lang=js&"
export * from "./remoteService.vue?vue&type=script&lang=js&"
import style0 from "./particulars.css?vue&type=style&index=0&id=4956e718&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4956e718",
  null
  
)

export default component.exports